import React, { useState } from "react";
import TeamMember from "../TeamMember/TeamMember";
import Profile from "./UserProfile";
import MessageTemplate from "../MessageTemplate/messageTemplate";
import Companyoverview from "../CompanyProfile/CompanyOverview";
import Button from "../elements/Button/Button";
import MastersPage from "../Masters/masters";
import Settings from "./Settings";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
const AddMember = () => {
  const [sideChange, setSideState] = useState("company");
  const [showMastersButtons, setShowMastersButtons] = useState(false);
  const [masterType, setMasterType] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { setting } = location.state || {};
  useEffect(() => {
    if (setting) {
      setSideState("settings");
    }
  }, [setting]);
  const handleSideBar = (state) => {
    setSideState(state);
    if (state === "masters") {
      setShowMastersButtons((prev) => !prev);
      setMasterType("Specialities");
    } else {
      setShowMastersButtons(false);
    }
    // Close sidebar on mobile after selection
    setIsSidebarOpen(false);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div>
      {/* Fixed Header with Navigation Toggle */}
      <header className="lg:hidden fixed top-0 left-0 right-0 bg-white border-b border-gray-200 shadow-sm z-50 h-16">
        <div className="flex items-center justify-between h-full px-4">
          <Button
            onClick={toggleSidebar}
            className="bg-transparent border-none p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <svg
              className="w-6 h-6 text-gray-700"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {isSidebarOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </Button>
          <h1 className="text-lg font-semibold text-gray-800">Settings</h1>
          <div className="w-10"></div> {/* Spacer for centering title */}
        </div>
      </header>

      {/* Backdrop overlay for mobile */}
      {isSidebarOpen && (
        <div
          className="lg:hidden fixed top-16 left-0 right-0 bottom-0 bg-black bg-opacity-50 z-30"
          onClick={toggleSidebar}
        ></div>
      )}

      <div className="flex flex-col lg:flex-row gap-4 sm:gap-6 lg:gap-4 xl:gap-6 min-h-screen lg:min-h-0">
        <div
          className={`${
            isSidebarOpen
              ? "translate-x-0"
              : "-translate-x-full lg:translate-x-0"
          } fixed lg:relative top-16 lg:top-0 left-0 h-[calc(100vh-4rem)] lg:h-[calc(100vh-2rem)] w-64 lg:w-64 xl:w-72 bg-white lg:bg-transparent shadow-lg lg:shadow-none z-40 lg:z-auto transition-transform duration-300 ease-in-out overflow-y-auto pt-4 lg:pt-4 pb-4 px-2 sm:px-4 lg:px-4 xl:px-6 flex-shrink-0`}
        >
          <Button
            className={`pl-2 pr-4 pt-3 pb-3 rounded-xl flex w-full mt-4 lg:mt-10 border-white text-sm sm:text-base ${
              sideChange === "company"
                ? "bg-gradient-to-r from-sky-300 to-emerald-100 text-green-800 shadow-md"
                : "bg-white hover:bg-gray-50"
            }`}
            onClick={() => handleSideBar("company")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="#00945b"
              className="mr-4"
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              stroke="#00945b"
            >
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"></path>
              </g>
            </svg>
            Company Overview
          </Button>
          <Button
            className={`pl-2 pr-4 pt-3 pb-3 rounded-xl flex w-full mt-2 border-white text-sm sm:text-base ${
              sideChange === "manage"
                ? "bg-gradient-to-r from-sky-300 to-emerald-100 text-green-800 shadow-md"
                : "bg-white hover:bg-gray-50"
            }`}
            onClick={() => handleSideBar("manage")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="#00945b"
              viewBox="0 0 24 24"
              stroke="#00945b"
              className={`w-6 h-8 mr-4`}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M16 14c3.866 0 7 3.134 7 7H1c0-3.866 3.134-7 7-7m4-6a4 4 0 100-8 4 4 0 000 8z"
              />
            </svg>
            Manage Users
          </Button>
          <Button
            className={`pl-2 pr-4 pt-3 pb-3 rounded-xl flex w-full mt-2 border-white text-sm sm:text-base ${
              sideChange === "message"
                ? "bg-gradient-to-r from-sky-300 to-emerald-100 text-green-800 shadow-md"
                : "bg-white hover:bg-gray-50"
            }`}
            onClick={() => handleSideBar("message")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              stroke="#00945b"
              className={`w-6 h-8 mr-4`}
              fill="#00945b"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 10h.01M12 10h.01M16 10h.01M21 12c0 3.866-3.134 7-7 7H7l-4 4V5c0-1.104.896-2 2-2h14c1.104 0 2 .896 2 2v7z"
              />
            </svg>
            Message Templates
          </Button>
          <Button
            className={`pl-2 pr-4 pt-3 pb-3 rounded-xl flex w-full mt-2 border-white text-sm sm:text-base ${
              sideChange === "user"
                ? "bg-gradient-to-r from-sky-300 to-emerald-100 text-green-800 shadow-md"
                : "bg-white hover:bg-gray-50"
            }`}
            onClick={() => handleSideBar("user")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="#00945b"
              viewBox="0 0 24 24"
              stroke="#00945b"
              className={`w-6 h-8 mr-4`}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M16 14c3.866 0 7 3.134 7 7H1c0-3.866 3.134-7 7-7m4-6a4 4 0 100-8 4 4 0 000 8z"
              />
            </svg>
            User Profile
          </Button>
          <Button
            className={`pl-2 pr-4 pt-3 pb-3 rounded-xl flex w-full mt-2 border-white text-sm sm:text-base ${
              sideChange === "settings"
                ? "bg-gradient-to-r from-sky-300 to-emerald-100 text-green-800 shadow-md"
                : "bg-white hover:bg-gray-50"
            }`}
            onClick={() => handleSideBar("settings")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              stroke="#00945b"
              x="0px"
              y="0px"
              strokeWidth={5}
              width="20"
              className="mr-4 text-[#059669] mt-1"
              fill="#059669"
              height="20"
              viewBox="0 0 50 50"
            >
              <path d="M 22.205078 2 A 1.0001 1.0001 0 0 0 21.21875 2.8378906 L 20.246094 8.7929688 C 19.076509 9.1331971 17.961243 9.5922728 16.910156 10.164062 L 11.996094 6.6542969 A 1.0001 1.0001 0 0 0 10.708984 6.7597656 L 6.8183594 10.646484 A 1.0001 1.0001 0 0 0 6.7070312 11.927734 L 10.164062 16.873047 C 9.583454 17.930271 9.1142098 19.051824 8.765625 20.232422 L 2.8359375 21.21875 A 1.0001 1.0001 0 0 0 2.0019531 22.205078 L 2.0019531 27.705078 A 1.0001 1.0001 0 0 0 2.8261719 28.691406 L 8.7597656 29.742188 C 9.1064607 30.920739 9.5727226 32.043065 10.154297 33.101562 L 6.6542969 37.998047 A 1.0001 1.0001 0 0 0 6.7597656 39.285156 L 10.648438 43.175781 A 1.0001 1.0001 0 0 0 11.927734 43.289062 L 16.882812 39.820312 C 17.936999 40.39548 19.054994 40.857928 20.228516 41.201172 L 21.21875 47.164062 A 1.0001 1.0001 0 0 0 22.205078 48 L 27.705078 48 A 1.0001 1.0001 0 0 0 28.691406 47.173828 L 29.751953 41.1875 C 30.920633 40.838997 32.033372 40.369697 33.082031 39.791016 L 38.070312 43.291016 A 1.0001 1.0001 0 0 0 39.351562 43.179688 L 43.240234 39.287109 A 1.0001 1.0001 0 0 0 43.34375 37.996094 L 39.787109 33.058594 C 40.355783 32.014958 40.813915 30.908875 41.154297 29.748047 L 47.171875 28.693359 A 1.0001 1.0001 0 0 0 47.998047 27.707031 L 47.998047 22.207031 A 1.0001 1.0001 0 0 0 47.160156 21.220703 L 41.152344 20.238281 C 40.80968 19.078827 40.350281 17.974723 39.78125 16.931641 L 43.289062 11.933594 A 1.0001 1.0001 0 0 0 43.177734 10.652344 L 39.287109 6.7636719 A 1.0001 1.0001 0 0 0 37.996094 6.6601562 L 33.072266 10.201172 C 32.023186 9.6248101 30.909713 9.1579916 29.738281 8.8125 L 28.691406 2.828125 A 1.0001 1.0001 0 0 0 27.705078 2 L 22.205078 2 z M 23.056641 4 L 26.865234 4 L 27.861328 9.6855469 A 1.0001 1.0001 0 0 0 28.603516 10.484375 C 30.066026 10.848832 31.439607 11.426549 32.693359 12.185547 A 1.0001 1.0001 0 0 0 33.794922 12.142578 L 38.474609 8.7792969 L 41.167969 11.472656 L 37.835938 16.220703 A 1.0001 1.0001 0 0 0 37.796875 17.310547 C 38.548366 18.561471 39.118333 19.926379 39.482422 21.380859 A 1.0001 1.0001 0 0 0 40.291016 22.125 L 45.998047 23.058594 L 45.998047 26.867188 L 40.279297 27.871094 A 1.0001 1.0001 0 0 0 39.482422 28.617188 C 39.122545 30.069817 38.552234 31.434687 37.800781 32.685547 A 1.0001 1.0001 0 0 0 37.845703 33.785156 L 41.224609 38.474609 L 38.53125 41.169922 L 33.791016 37.84375 A 1.0001 1.0001 0 0 0 32.697266 37.808594 C 31.44975 38.567585 30.074755 39.148028 28.617188 39.517578 A 1.0001 1.0001 0 0 0 27.876953 40.3125 L 26.867188 46 L 23.052734 46 L 22.111328 40.337891 A 1.0001 1.0001 0 0 0 21.365234 39.53125 C 19.90185 39.170557 18.522094 38.59371 17.259766 37.835938 A 1.0001 1.0001 0 0 0 16.171875 37.875 L 11.46875 41.169922 L 8.7734375 38.470703 L 12.097656 33.824219 A 1.0001 1.0001 0 0 0 12.138672 32.724609 C 11.372652 31.458855 10.793319 30.079213 10.427734 28.609375 A 1.0001 1.0001 0 0 0 9.6328125 27.867188 L 4.0019531 26.867188 L 4.0019531 23.052734 L 9.6289062 22.117188 A 1.0001 1.0001 0 0 0 10.435547 21.373047 C 10.804273 19.898143 11.383325 18.518729 12.146484 17.255859 A 1.0001 1.0001 0 0 0 12.111328 16.164062 L 8.8261719 11.46875 L 11.523438 8.7734375 L 16.185547 12.105469 A 1.0001 1.0001 0 0 0 17.28125 12.148438 C 18.536908 11.394293 19.919867 10.822081 21.384766 10.462891 A 1.0001 1.0001 0 0 0 22.132812 9.6523438 L 23.056641 4 z M 25 17 C 20.593567 17 17 20.593567 17 25 C 17 29.406433 20.593567 33 25 33 C 29.406433 33 33 29.406433 33 25 C 33 20.593567 29.406433 17 25 17 z M 25 19 C 28.325553 19 31 21.674447 31 25 C 31 28.325553 28.325553 31 25 31 C 21.674447 31 19 28.325553 19 25 C 19 21.674447 21.674447 19 25 19 z"></path>
            </svg>
            Settings
          </Button>
          <Button
            className={`pl-2 pr-4 pt-3 pb-3 rounded-xl flex w-full mt-2 border-white text-sm sm:text-base ${
              sideChange === "masters"
                ? "bg-gradient-to-r from-sky-300 to-emerald-100 text-green-800 shadow-md"
                : "bg-white hover:bg-gray-50"
            }`}
            onClick={() => handleSideBar("masters")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="#00945b"
              viewBox="0 0 24 24"
              stroke="#00945b"
              className={`w-6 h-8 mr-4`}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 14L2 9l10-5 10 5-10 5zm0 0v6m-5 0h10"
              />
            </svg>
            Masters
          </Button>

          {showMastersButtons && (
            <div className="mt-2 space-y-2 pb-4 pl-4">
              <Button
                className={`pl-2 pr-4 pt-3 pb-3 rounded-xl flex w-full mt-2 border-white text-sm sm:text-base ${
                  masterType === "Specialities"
                    ? "bg-gradient-to-r from-sky-300 to-emerald-100 text-green-800 shadow-md"
                    : "bg-white hover:bg-gray-50"
                }`}
                onClick={() => setMasterType("Specialities")}
              >
                Specialities
              </Button>
              <Button
                className={`pl-2 pr-4 pt-3 pb-3 rounded-xl flex w-full mt-2 border-white text-sm sm:text-base ${
                  masterType === "Skills"
                    ? "bg-gradient-to-r from-sky-300 to-emerald-100 text-green-800 shadow-md"
                    : "bg-white hover:bg-gray-50"
                }`}
                onClick={() => setMasterType("Skills")}
              >
                Skills
              </Button>
              <Button
                className={`pl-2 pr-4 pt-3 pb-3 rounded-xl flex w-full mt-2 border-white text-sm sm:text-base ${
                  masterType === "Search"
                    ? "bg-gradient-to-r from-sky-300 to-emerald-100 text-green-800 shadow-md"
                    : "bg-white hover:bg-gray-50"
                }`}
                onClick={() => setMasterType("Search")}
              >
                Search Keyword
              </Button>
              <Button
                className={`pl-2 pr-4 pt-3 pb-3 rounded-xl flex w-full mt-2 border-white text-sm sm:text-base ${
                  masterType === "Questions"
                    ? "bg-gradient-to-r from-sky-300 to-emerald-100 text-green-800 shadow-md"
                    : "bg-white hover:bg-gray-50"
                }`}
                onClick={() => setMasterType("Questions")}
              >
                Screening Questions
              </Button>
            </div>
          )}
        </div>
        <div className="flex-1 w-full min-w-0 mt-16 lg:mt-0 px-2 sm:px-4 lg:px-2 xl:px-4">
          <div className="max-w-full overflow-hidden">
            {sideChange === "manage" && <TeamMember />}
            {sideChange === "company" && <Companyoverview />}
            {sideChange === "message" && <MessageTemplate />}
            {sideChange === "user" && <Profile />}
            {sideChange === "settings" && <Settings />}
            {sideChange === "masters" && masterType && (
              <MastersPage type={masterType} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default AddMember;
